import React from 'react';

import { Icon, IconButton } from './ui';

// The favourite / priority star. The `.star` wrapper and the caller's classes are unchanged layout
// hooks (cards right-align / position it, order rows give it a fixed box); the control inside is an
// IconButton. Product favourites (`product-icon`) keep their heart, everything else the star.
const StarIcon = ({ active, onClick, iconClassName = '', className = '', label = 'Favourite' }) => (
  <div className={['star', className, iconClassName].filter(Boolean).join(' ')}>
    <IconButton
      variant="ghost"
      size="sm"
      label={label}
      pressed={!!active}
      data-btn="favourite-toggle"
      onClick={onClick}
    >
      <Icon
        name={/\bproduct-icon\b/.test(iconClassName) ? 'Heart' : 'Star'}
        size="sm"
        fill={active ? 'currentColor' : 'none'}
      />
    </IconButton>
  </div>
);

export default StarIcon;
